import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = { class: "text-nowrap pr-3 min-width-0" }
const _hoisted_3 = { class: "p-0 m-0 text-white" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-truncate"
}
const _hoisted_5 = { class: "flex-fill text-right" }

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";
import {computed} from "vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {EVENT_OPEN_CALL_TAB} from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";


const __default__ = {
    name: "BuddyListCurrentCall"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    call: {}
  },
  setup(__props: any) {

let props = __props;

let callTime = computed(() => {
    return props.call.getCallTimeString();
});

let username = computed(() => {
    return props.call.getCallData()?.username;
})

async function goToCall() {
    if (username.value) {
        await OperatorApplicationBuddyList.addClientAndOpenByUsername(username.value);
        setTimeout(() => {
            OperatorApplicationEventManager.emit(EVENT_OPEN_CALL_TAB, username.value);
        }, 1);
    }
}

let userdata = computed(() => {
    if (username.value) {
        return ClientUserdataStore.getByUsername(username.value);
    }
    return null;
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (__props.call)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "d-flex w-100 align-items-center call h-auto el-button el-button--success text-left",
          type: "success",
          onClick: goToCall
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, _toDisplayString(`Звонок` + (_unref(callTime) ? `, ${_unref(callTime)}` : '')), 1),
            (_unref(userdata))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(userdata).displayDescr), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              circle: ""
            }, {
              default: _withCtx(() => [
                _createVNode(FontAwesomeIcon, { icon: "phone" })
              ]),
              _: 1
            })), [
              [
                _directive_on_native,
                () => __props.call.hangUp(),
                "click",
                { stop: true }
              ]
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})